<div class="leasingModal firstClickBudgetModal">
	<div class="closeContainer">
        <mat-icon (click)="cancel()">close</mat-icon>
	</div>
	<h1>Huomioi kuukausibudjetissa</h1>
	<div mat-dialog-content>
		<p>
			Vakuutusmaksut ja vuosittainen ajoneuvovero tulevat kuukausimaksun päälle. Huollot sisältyvät osaan sopimuksista. Yhteensä näistä voi syntyä <strong>noin 100 euron ylimääräinen kuukausikulu</strong>.
		</p>
	</div>
	<div mat-dialog-actions align="end">
		<button class="orange button" (click)="ok()">Ok, ymmärrän</button>
	</div>
</div>